export default "__VITE_ASSET__C6nv8cBT__"